import { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Avatar } from "@/components/common/Avatar";
import { cn } from "@/lib/utils";

// Reaction chip → "who reacted" popover (names + avatars) with a toggle for your own reaction (bfb_6d3dbbc1c).
export function ReactionChip({ emoji, users, mine, resolveUser, onToggle, testid }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn(
            "reaction-pop flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs transition-colors",
            mine ? "border-bloq-mint/50 bg-bloq-mint/15 text-bloq-mint" : "border-white/12 bg-bloq-s2 text-bloq-muted hover:text-white",
          )}
          data-testid={testid}
          aria-label={`${emoji} ${users.length} — see who reacted`}
        >
          {emoji} {users.length}
        </button>
      </PopoverTrigger>
      <PopoverContent side="top" align="start" sideOffset={6} className="w-60 rounded-2xl border-white/10 bg-bloq-s1 p-2 shadow-2xl" data-testid={`${testid}-who`}>
        <div className="mb-1 px-1 text-[11px] font-semibold uppercase tracking-wider text-bloq-muted">
          {emoji} · {users.length} {users.length === 1 ? "reaction" : "reactions"}
        </div>
        <ul className="max-h-48 space-y-0.5 overflow-y-auto">
          {users.map((id) => {
            const u = resolveUser(id);
            return (
              <li key={id} className="flex items-center gap-2 rounded-lg px-1 py-1" data-testid={`reactor-${id}`}>
                <Avatar user={u} size="xs" flair={false} />
                <span className="min-w-0 flex-1 truncate text-sm text-white">{u?.display_name || (u?.username ? `@${u.username}` : "Member")}</span>
                {u?.isMe && <span className="text-[11px] text-bloq-muted">you</span>}
              </li>
            );
          })}
        </ul>
        <button
          type="button"
          onClick={() => { onToggle(); setOpen(false); }}
          className="mt-2 w-full rounded-full border border-white/10 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-white/5"
          data-testid={`${testid}-toggle`}
        >
          {mine ? `Remove your ${emoji}` : `React with ${emoji}`}
        </button>
      </PopoverContent>
    </Popover>
  );
}
